import './navtop.scss';
import IneLogo from '../../Utils/img/ine.svg';
import Signout from '../../Utils/img/outlg.svg';
import { useAuth } from '../../hooks/useAuth';
import { useContext, useState } from 'react';


function Navtop() {
    const { logout } = useAuth();
    return(
        <>
            <div className='navtp'>
                <div className='navtp__lg'>
                    {/* <img className='navtp__lg--img' src={IneLogo} alt="INE Logo"></img> */}
                </div>
                <div className='navtp__tl'>
                    <h1 className='navtp__tl--title'>
                        Indicador 404 (IDX404)
                    </h1>
                </div>
                <div className='navtp__cl'>
                    <div className='navtp__cl__content'>
                        <div className='navtp__cl__content__txt'>
                            <div className='navtp__cl__content__txt--title'>Bienvenido</div>
                        </div>
                        <div className='navtp__cl__content__sign' onClick={logout}>
                            <img className='navtp__cl__content__sign--ic' src={Signout} alt="Cerrar sesion"></img>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Navtop;